import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 6h-3a2 2 0 0 0 -2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2 -2v-3.357","key":"svg-0"}],["path",{"d":"M13 5a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4","key":"svg-1"}],["path",{"d":"M13.5 10.5l-5.5 5.5","key":"svg-2"}],["path",{"d":"M8 11v5h5","key":"svg-3"}]]

const IconQueuePopIn = createReactComponent('outline', 'queue-pop-in', 'QueuePopIn', __iconNode);

export default IconQueuePopIn;